import useSWR from 'swr';

import useAcl from '@/hooks/user/useAcl';

// Utils
import { get } from '@/utils/client';
import { injectEndpointUrlParams } from '@/utils/injectEndpointUrlParams';

import { aclFeatures } from '@/lib/acl/aclFeatures';

// Lib
import {
    COLLABORATION_SHARING_LINK,
    COLLABORATION_SHARING_LINK_GROUP
} from '@/routes/apiEndpoints';

const useCollaborationSettingsLink = ({ SPID, activeGroupId, options = {} }) => {
    const { hasAcl } = useAcl();

    let url = injectEndpointUrlParams(COLLABORATION_SHARING_LINK, { SPID: SPID });

    if (activeGroupId) {
        url = injectEndpointUrlParams(COLLABORATION_SHARING_LINK_GROUP, {
            GROUP_ID: activeGroupId
        });
    }

    const {
        data: link,
        mutate: mutateLink,
        error: linkError
    } = useSWR(
        hasAcl(aclFeatures.publishing.external_collaboration.read) ? url : null,
        (url) => get(url).then((res) => res.data),
        {
            shouldRetryOnError: false,
            ...options
        }
    );

    return {
        link,
        mutateLink,
        linkError,
        isLoading: !link && !linkError
    };
};

export default useCollaborationSettingsLink;
